import React from 'react'
// import CareerJoiners from './CareerJoiners'
import SubHeader from '../../components/SubHeader'
// import CareerCelebrate from './CareerCelebrate'
// import CareerLocation from './CareerLocation'
import HealthcareBusinesse from '../Industries/Healthcare/HealthcareBusinesse';
import CareerExperience from './CareerExperience'
// import CareerApplications from './CareerApplications'

export default function Career() {
    const subheadData = {
        image: '../assets/images/career-banner.webp',
        pagename: 'Career',
        subhead: 'Build your future with Supershine through meaningful growth.',
    }


    // const careerService = {
    //     customClass: "",
    //     sections: [
    //         {
    //             subtitle: "Supershine",
    //             bottomsubtitle: "",
    //             title: "People Power Our Mission",
    //             description: [
    //                 "At Supershine, our team drives innovation through expertise, collaboration, and commitment to excellence. Their dedication ensures we deliver world-class solutions globally.",
    //                 "We foster a culture where every member grows, contributes meaningfully, and shares in our collective success; building reliable, efficient solutions that matter worldwide.",
    //                 "Building world-class solutions requires a unified team aligned around shared purpose. We invest in continuous learning, encourage bold ideas, and celebrate success together. At Supershine, excellence is always a collective achievement.",
    //             ],
    //             image: "/assets/images/career-celebration.webp",
    //             alt: "Tower Image",
    //             reverse: false,
    //         },


    //     ],
    // };


    const businessData = {
        title: "What Our Team Says",
        description:
            "Discover what it's like to work at Supershine; real stories of growth, innovation, and impact from the people building excellence every day.",
        testimonials: [

            {
                rating: 5,
                text: "“Being part of Supershine means delivering technically advanced, energy-efficient laundry solutions with a strong commitment to quality, safety, innovation, and customer satisfaction.”",
                client: "Mr.  Sanjay Upadhyay  - Engineering",
            },

            {
                rating: 5,
                text: "“Supershine Laundry is an organization that provides exposure to all levels of business,where individuals get the opportunity to learn & perform a variety of tasks at a professional level,this experience is highly beneficial for career growth.”",
                client: "Mr. Gurmeet Singh - Accounts",
            },
            {
                rating: 5,
                text: "“Working at Supershine has been a rewarding experience. The supportive environment, teamwork, and growth opportunities motivate me to perform my best every day.”",
                client: "Mr. Saurabh Kumar - Sales & Marketing",
            },
            
        ],
    };
    return (
        <>
            <SubHeader subheadData={subheadData} />
            {/* <CareerJoiners /> */}
            {/* <CareerCelebrate data={careerService} /> */}
            {/* <CareerLocation /> */}
            <HealthcareBusinesse data={businessData}  extraClass ="career-business"/>
            <CareerExperience />
            {/* <CareerApplications /> */}
        </>
    )
}
